import { useMemo } from 'react';

import { FeatureFlag } from '@revelio/core';

import {
  FilterId,
  type PrimaryFilterId,
} from '../../next/CustomDash/filters/types/filters';
import { useUnleashFlag } from './use-unleash-flag';

/** Callers fold in Unleash readiness before using these live flag values. */
export type ActivityFilterFlags = {
  companyPages: boolean;
  // Always `true`: only Company pages still gate the filter. Kept because
  // callers fold Unleash readiness into it and dash-meta reads it from the
  // turn-step context.
  otherPages: boolean;
};

export const useActivityFilterFlags = (): ActivityFilterFlags => {
  const companyPages = useUnleashFlag(FeatureFlag.ActivityTaxonomyCompany);
  return useMemo(() => ({ companyPages, otherPages: true }), [companyPages]);
};

export const isActivityFilterFlagOn = (
  flags: ActivityFilterFlags,
  { isCompanyPage }: { isCompanyPage: boolean }
): boolean => (isCompanyPage ? flags.companyPages : flags.otherPages);

/** Activity-primary pages require their primary filter regardless of rollout flags. */
export const isActivityFilterOnForPrimary = (
  flags: ActivityFilterFlags,
  primaryFilterId: PrimaryFilterId | undefined
): boolean =>
  primaryFilterId === FilterId.ACTIVITY ||
  isActivityFilterFlagOn(flags, {
    isCompanyPage: primaryFilterId === FilterId.COMPANY,
  });
